<template>
    <div class="pt-select-div" v-if="$attrs.mode == 'multiple'">
        <a-select  :allowClear="allowClear" :style="selectStyle" :filterOption="filterOption" showSearch @change="changeValue" v-model="input" v-bind="$attrs" v-on="$listeners" :placeholder=placeholder>
            <a-icon slot="suffixIcon" type="caret-down" />
            <a-select-option v-for="(item,inde) in users" :key="inde" :disabled="disabledUsers.indexOf(item.accountid) != -1" :value="item.accountid">{{item.userName}}</a-select-option>
        </a-select>
        <a-icon class="multiple-icon" :class="open?'openClass':''" type="caret-down"></a-icon>
    </div>
   <a-select v-else :allowClear="allowClear"  :filterOption="filterOption" showSearch @change="changeValue" v-model="input" v-bind="$attrs" v-on="$listeners" :placeholder=placeholder>
     <a-icon slot="suffixIcon" type="caret-down" />
     <a-select-option v-for="(item,inde) in users" :key="inde" :disabled="disabledUsers.indexOf(item.accountid) != -1" :value="item.accountid">{{item.userName}}</a-select-option>
   </a-select>
</template>

<script>
  import dealConfirmApi from '@/api/mine/dealConfirm'
  export default {
    name: 'ptAllUserSelect',
    props:{
      placeholder:{
        type:String,
      },
      allowClear:{
        type:Boolean,
        default:true,
      },
      value:{
        type: [Object, Array] | String,
      },
      disabledUsers:{
        type:Array,
        default:()=>{return []}
      },
      companyId:{
        type:String,
      },
      selectStyle:{
        type:Object,
        default:()=>{
          return {width:'100%'}
        }
      },
    },
    data() {
      return {
        input:this.value,
        users:[],
        open:false,
      }
    },
    watch:{
      value (val) {
        this.input = val
        console.log("this.input",val)
      },
      input(val){
        this.$emit('input',val)
      },
      companyId(){
        this.initData()
      },
    },
    mounted(){
      this.initData()
    },
    methods:{
      dropdownVisibleChange(open){
        this.open = open
      },
      filterOption(input, option){
        return (
          option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
        );
      },
      initData() {
        let queryVO ={}
        if(this.companyId){
          queryVO.companyId = this.companyId
        }
        dealConfirmApi.selectAllUsers(queryVO).then(res => {
          if (res.code == 1) {
            this.users = res.data
          }
        })
      },
      changeValue(value){
        this.$emit('input',value)
        this.$emit('change',value);
      }
    }
  }
</script>

<style scoped lang="less">
    .pt-select-div{
        position: relative;
        width: 100%;
        display: inline;
        /deep/ .ant-select-selection--multiple .ant-select-selection__placeholder{
            margin-left: 0px;
        }
        .multiple-icon{
            position: absolute;
            color: rgba(0, 0, 0, 0.25);
            right: 11px;
            top: 10px;
            font-size: 12px;
        }
        .openClass{
            transform: rotate(180deg);
        }
    }
</style>